import AppointmentDetails from '../components/consultations-made/appointment-details'

export default {
  AppointmentDetails
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/active-agenda/resources/components.js